// packages/apps/pro-studio/src/stores/utils/continuous-multi-selection.ts
//
// PSTUDIO-4229: ONE definition of "the gesture acts on the whole selection".
//
// Three call sites carried a hand-written copy of it — the row context menu's
// insert/paste anchoring, the drag wiring in `draggable-row.tsx`, and the pure
// `resolveRowPasteTargets` — and the resolver's own docblock described itself as
// mirroring the component. They read their inputs from different places (a live
// store for the two components, a SNAPSHOT for the paste resolver, which runs
// after the menu closed and the selection was cleared), so the shared thing is
// the RULE, not the inputs: this function takes the three facts and answers.
//
// Taking the facts rather than the ids also keeps the store's reader O(1): a
// version that took `selectedRowIds` would copy the observable set on every
// render of every visible row.

export interface ContinuousMultiSelectionInput {
  /** Whether the row the gesture was made on is itself selected. */
  isRowSelected: boolean;
  /** How many rows the selection holds. */
  selectedCount: number;
  /** Whether those rows are adjacent in visual order. */
  isSelectionContinuous: boolean;
}

/**
 * True when the gesture's row sits inside a CONTINUOUS selection of more than
 * one row — the case where the selection, not the single row, is the target.
 *
 * Continuity matters because these gestures collapse onto one slot (a replace
 * paste) or anchor to a boundary (insert above/below), which only reads as one
 * block when the rows are adjacent.
 */
export function isPartOfContinuousMultiSelection({
  isRowSelected,
  selectedCount,
  isSelectionContinuous,
}: ContinuousMultiSelectionInput): boolean {
  return selectedCount > 1 && isSelectionContinuous && isRowSelected;
}
